import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_REDEEM_PROMO_CODE = createRequestTypes(
  'script-helpers/REDEEM_PROMO_CODE',
);
